const router = [
    {
        path: '/screen/splitScreen',
        name: 'splitScreen',
        component: () => import('@/views/teacher/screen/splitScreen'),
        meta: { title: '分屏展示学生信息', icon: 'table',role: "教师" },
        hidden: true
    },
    {// 监控中心屏1
        path: '/screen/finishStat',
        name: 'finishStat',
        component: () => import('@/views/teacher/screen/finishStat'),
        meta: { title: '全员排名', icon: 'form',role: "教师" },
        hidden: true
    },
    // 监控中心屏2
    {
        path: '/screen/groupRank',
        name: 'groupRank',
        component: () => import('@/views/teacher/screen/groupRank'),
        meta: { title: '所有组的单词排名', icon: 'form',role: "教师" },
        hidden: true
    },
    // 监控中心屏3
    {
        path: '/screen/stuAdvanceRank',
        name: 'stuAdvanceRank',
        component: () => import('@/views/teacher/screen/stuAdvanceRank'),
        meta: { title: '学员进步排名', icon: 'form',role: "教师" },
        hidden: true
    },
    // 监控中心屏4
    {
        path: '/screen/stuErrorStat',
        name: 'stuErrorStat',
        component: () => import('@/views/teacher/screen/stuErrorStat'),
        meta: { title: '班级错题本', icon: 'form',role: "教师" },
        hidden: true
    },
]
export default router
